export const Types = {
  TOGGLE_MODAL: "TOGGLE_MODAL"
};

//---------------------------------------//
//---------------------------------------//

const initialState = {}; 

const Reducer = (state=initialState, action) =>{
  switch(action.type){
    case Types.TOGGLE_MODAL:
      return Object.assign(
        {},
        state,
        action.payload
      );
      break;
    default:
      return state;
      break;
  }
};
export default Reducer;

//---------------------------------------//
//---------------------------------------//

export const ModalToggle = (name, status) =>{
  return {
    type: Types.TOGGLE_MODAL,
    payload: {
      [name]: status
    }
  }
};

export const ExecuteToggle = (name) =>{
  return (dispatch, getState)=>{
    let state = getState();
    let status = !state.modals[name];
    dispatch(ModalToggle(name, status));
  }
}